// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-portfolio-navitem {
  border: 1px solid #e7e9eb;
  border-radius: 5px;
  padding: 3px 5px;
  cursor: pointer;
  box-shadow: rgba(0, 0, 0, 0.07) 0px 1px 4px;
  width: 130px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.3s ease, border-bottom 0.3s ease;
}

.header-portfolio {
  display: flex;
  justify-content: start;
  align-items: center;
  background-color: #ffffff;
  position: sticky;
  top: 0;
  z-index: 100;
  box-shadow: rgba(50, 50, 93, 0.09) 0px 2px 5px -1px, rgba(0, 0, 0, 0.09) 0px 1px 3px -1px;
  height: 70px;
}

.header-portfolio-navitem:hover {
  color: #007bff;
  border-bottom: 1px solid #007bff;
}

.header-portfolio-navitem:focus {
  outline: none;
  /* Remove default focus outline */
  color: #007bff;
  /* Focus color */
}

.candidate-logout {
  background-color: #017EBD;
  color: #ffffff;
  border: 1px solid #017EBD;
  border-radius: 8px;
}

.candidate-logout:hover {
  background-color: #007bff;
  color: #ffffff;
  border: 1px solid #007bff;
}

.candidate-logout:focus {
  outline: none;
  /* Remove default focus outline */
  color: #007bff;
  /* Focus color */
}`, "",{"version":3,"sources":["webpack://./../portfolio/src/pages/CandidateProfileEditor/CandidateProfileEditor.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,2CAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,oDAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,MAAA;EACA,YAAA;EACA,yFAAA;EAEA,YAAA;AAAF;;AAGA;EACE,cAAA;EACA,gCAAA;AAAF;;AAGA;EACE,aAAA;EAAe,iCAAA;EACf,cAAA;EAAgB,gBAAA;AAElB;;AACA;EACE,yBAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;AAEF;;AACA;EACE,yBAAA;EACA,cAAA;EACA,yBAAA;AAEF;;AACA;EACE,aAAA;EAAe,iCAAA;EACf,cAAA;EAAgB,gBAAA;AAIlB","sourcesContent":[".header-portfolio-navitem {\n  border: 1px solid #e7e9eb;\n  border-radius: 5px;\n  padding: 3px 5px;\n  cursor: pointer;\n  box-shadow: rgba(0, 0, 0, 0.07) 0px 1px 4px;\n  width: 130px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: color 0.3s ease, border-bottom 0.3s ease;\n}\n\n.header-portfolio {\n  display: flex;\n  justify-content: start;\n  align-items: center;\n  background-color: #ffffff;\n  position: sticky;\n  top: 0;\n  z-index: 100;\n  box-shadow: rgba(50, 50, 93, 0.09) 0px 2px 5px -1px,\n    rgba(0, 0, 0, 0.09) 0px 1px 3px -1px;\n  height: 70px;\n}\n\n.header-portfolio-navitem:hover {\n  color: #007bff;\n  border-bottom: 1px solid #007bff;\n}\n\n.header-portfolio-navitem:focus {\n  outline: none; /* Remove default focus outline */\n  color: #007bff; /* Focus color */\n}\n\n.candidate-logout {\n  background-color: #017EBD;\n  color: #ffffff;\n  border: 1px solid #017EBD;\n  border-radius: 8px;\n}\n\n.candidate-logout:hover {\n  background-color: #007bff;\n  color: #ffffff;\n  border: 1px solid #007bff;\n}\n\n.candidate-logout:focus {\n  outline: none; /* Remove default focus outline */\n  color: #007bff; /* Focus color */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
